import { X, ExternalLink } from 'lucide-react'

interface WechatGuideProps {
  visible: boolean
  onDismiss: () => void
}

export function WechatGuide({ visible, onDismiss }: WechatGuideProps) {
  if (!visible) return null

  return (
    <div className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm flex flex-col items-center justify-center p-6">
      {/* Arrow pointing to top-right */}
      <div className="mb-8 flex flex-col items-center">
        <svg className="w-16 h-16 text-white animate-bounce" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M7 17l9.2-9.2M17 17V7H7" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <p className="text-white/60 text-sm mt-2">点击右上角 ···</p>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 max-w-xs w-full text-center shadow-2xl">
        <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-4">
          <ExternalLink className="h-6 w-6 text-green-600" />
        </div>
        <h3 className="text-lg font-semibold mb-2">在浏览器中打开</h3>
        <p className="text-sm text-muted-foreground mb-4">
          微信内置浏览器不支持完整功能，请在浏览器中打开获得最佳体验
        </p>
        <button
          onClick={onDismiss}
          className="text-sm text-primary hover:underline"
        >
          我知道了
        </button>
      </div>
    </div>
  )
}
